import { render, staticRenderFns } from "./OtpSubs.vue?vue&type=template&id=108a469b&scoped=true"
import script from "./OtpSubs.vue?vue&type=script&lang=js"
export * from "./OtpSubs.vue?vue&type=script&lang=js"
import style0 from "./OtpSubs.vue?vue&type=style&index=0&id=108a469b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a469b",
  null
  
)

export default component.exports